{% block swag_language_pack_settings %}
<sw-page class="swag-language-pack-settings">

    {% block swag_language_pack_settings_header %}
    <template #smart-bar-header>
        <h2>
            <span>{{ $t('sw-settings.index.title') }}</span>
            <mt-icon
                name="regular-chevron-right-xs"
                size="14px"
            />
            <span>{{ $t('swag-language-pack.settings.header') }}</span>
        </h2>
    </template>
    {% endblock %}

    {% block swag_language_pack_settings_actions %}
    <template #smart-bar-actions>

        {% block swag_language_pack_settings_actions_save %}
        <sw-button-process
            class="swag-language-pack-settings__save-action"
            variant="primary"
            :process-success="isSaveSuccessful"
            :disabled="!acl.can('swag_language_pack_language:update')"
            @process-finish="onSaveFinish"
            @click="onSave"
        >
            {{ $t('global.default.save') }}
        </sw-button-process>
        {% endblock %}

    </template>
    {% endblock %}

    {% block swag_language_pack_settings_content %}
    <template #content>

        {% block swag_language_pack_settings_content_card_view %}
        <sw-card-view>
            <mt-banner
                v-if="shopwareHasTranslationSystem"
                class="swag-language-pack-settings__deprecation-banner"
                variant="info"
            >
                <p v-html="$t('swag-language-pack.settings.deprecationBanner')"></p>
            </mt-banner>

            {% block swag_language_pack_settings_content_tabs %}
            <sw-tabs
                v-if="!isLoading"
                class="swag-language-pack-settings__tabs"
                position-identifier="swag-language-pack-settings__tabs"
            >

                {% block swag_language_pack_settings_content_tabs_administration %}
                <sw-tabs-item
                    class="swag-language-pack-settings__tab-administration"
                    :route="{ name: 'swag.language.pack.index.administration' }"
                    :disabled="!acl.can('language.viewer')"
                >
                    {{ $t('swag-language-pack.settings.card.administration.tabTitle') }}
                </sw-tabs-item>
                {% endblock %}

                {% block swag_language_pack_settings_content_tabs_sales_channel %}
                <sw-tabs-item
                    class="swag-language-pack-settings__tab-sales-channel"
                    :route="{ name: 'swag.language.pack.index.salesChannel' }"
                    :disabled="!acl.can('language.viewer')"
                >
                    {{ $t('swag-language-pack.settings.card.salesChannel.tabTitle') }}
                </sw-tabs-item>
                {% endblock %}
            </sw-tabs>
            {% endblock %}

            {% block swag_language_pack_settings_content_router_view %}
            <router-view
                v-if="!isLoading"
                :is-loading="isLoading"
                :pack-languages="packLanguages"
            />
            {% endblock %}

            {% block swag_language_pack_settings_content_loader %}
            <mt-loader v-if="isLoading"/>
            {% endblock %}

            {% block swag_language_pack_settings_content_verify_user_modal %}
            <sw-verify-user-modal
                v-if="confirmPasswordModal"
                @verified="savePackLanguages"
                @close="onCloseConfirmPasswordModal"
            />
            {% endblock %}

        </sw-card-view>
        {% endblock %}

    </template>
    {% endblock %}

</sw-page>
{% endblock %}
